module.exports = "<span [innerHTML]=\"getSafeSvg(size)\"></span>"


//////////////////
// WEBPACK FOOTER
// ./src/templates/loader.html
// module id = 1053
// module chunks = 3